import { render, staticRenderFns } from "./pattern_maker_home.vue?vue&type=template&id=f7b036ca"
import script from "./pattern_maker_home.vue?vue&type=script&lang=js"
export * from "./pattern_maker_home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports